import { Container, spine } from "pixi.js";
import { SpineConst } from "../../../Constants/SpineConst";
import { GameModel } from "../../../Models/GameModel";
import { SpineContainer } from "../../Common/SpineContainer";

enum AnimationEnum {
    vfx_explosion = "fx_explosion",
}

export class VFXController extends SpineContainer {
    public container: Container;
    public spine: spine.Spine;
    constructor(model: GameModel, animation = ["fx_explosion"], resource = SpineConst.VFXExplosion) {
        super(model, animation, resource);
        this.setAnimation("fx_explosion", false);

    }

    // prepareSpine(){
    //     const animations = Object.values(AnimationEnum);
    //     for (let i = 0; i < animations.length; i++) {
    //         //@ts-ignore
    //         animations[i] = animations[i].replace('xxx', this.animName);
    //     }


    //     this.spineData = this.model.spineResources['vfxBoom']?.spineData;
    //     if (!this.spineData) {
    //         setTimeout(() => {
    //             this.prepareSpine();
    //         }, 10);
    //     }
    //     if (this.spineData)
    //         this.spine = new PIXI.spine.Spine(this.spineData);
    //     else
    //         console.warn('cant get spine');

    //     if (this.spine) {
    //         this.container.addChild(this.spine);

    //         for (const index in animations) {
    //             this.spine.state.addAnimation(0, animations[index], false, 0);
    //         }
    //         this.setAnimation(AnimationEnum.vfx_explosion, false);
    //     }
    // }

    // public setAnimation(key: string, loop: boolean): void {
    //     if (this.spine && this.spine.state) {
    //         if (this.spine.state.hasAnimation(key)) {
    //             if (this.currAnimation !== key) {
    //                 this.spine.visible = true;
    //                 this.spine.autoUpdate = true;
    //                 this.spine.state.timeScale = 1;
    //                 this.currentTrack = this.spine.state.setAnimation(0, key, loop);
    //                 this.currAnimation = key;
    //             }
    //         } else {
    //             this.resetAnimation();
    //         }
    //     } else {
    //         this.resetAnimation();
    //     }
    // }

    // public resetAnimation(): void {
    //     this.currAnimation = '';

    //     if (this.spine && this.spine.state) {
    //         this.spine.visible = false;
    //         this.spine.autoUpdate = false;
    //         this.currentTrack = this.spine.state.setEmptyAnimation(0, 0);
    //     }
    // }

}